import React from 'react';
import { Col, Row, Skeleton } from 'antd';
import { SkeletonFormItem } from 'common/components/Skeleton/SkeletonFormItem';

export const AnnouncementFormSkeleton: React.FC = () => {
  return (
    <div className="mt-5">
      <Row gutter={[28, 0]}>
        <Col span={12}>
          <SkeletonFormItem label="Announcement name">
            <Skeleton.Input active />
          </SkeletonFormItem>
        </Col>
        <Col span={12}>
          <SkeletonFormItem label="Announcement dates">
            <Skeleton.Input active />
          </SkeletonFormItem>
        </Col>
        <Col span={12}>
          <SkeletonFormItem label="Store">
            <Skeleton.Input active />
          </SkeletonFormItem>
        </Col>
        <Col span={12}>
          <SkeletonFormItem label="Announcement hyperlink">
            <Skeleton.Input active />
          </SkeletonFormItem>
        </Col>
        <Col span={24}>
          <SkeletonFormItem label="Description">
            <Skeleton.Input active />
          </SkeletonFormItem>
        </Col>
      </Row>

      <SkeletonFormItem label="Image">
        <Skeleton.Image />
      </SkeletonFormItem>

      <Row className="flex-noWrap" justify="space-between" align="middle">
        <Col span={16}>
          <Skeleton.Button className="mr-5" />
          <Skeleton.Button />
        </Col>
      </Row>
    </div>
  );
};
